import React, { Component } from "react";
import { translate } from "react-i18next";
import styled from "styled-components";
import { Container } from "react-grid-system";
import Colors from "../../shared/colors";
import BannerTop from "../../components/bannertop/bannertop.component";
import Box from "../../containers/Box/box.container";
import Maps from "../../containers/Maps/Maps.container";
import NetIconMembro from "../../assets/images/Icons Network/ic-badge-membro.svg";
import FaMap from "react-icons/lib/fa/map";
import MdApps from "react-icons/lib/md/apps";
import List from "../../containers/List/list";
import FaFilter from "react-icons/lib/fa/filter";

class Restaurants extends Component {
  state = {
    view: true,
    order: parseInt(localStorage.getItem("order"), 0),
    open: false,
  };

  UNSAFE_componentWillUpdate() {
    const requestLang = window.location.pathname.split("/");
    const size = requestLang.length - 1;

    if (requestLang[size] === "") {
      let url =
        "/" + this.props.i18n.language + "/" + this.props.t("restaurantes");
      this.props.history.replace(url, true);
    }

    let lang = requestLang[1];
    if (lang !== this.props.i18n.language) {
      let url =
        "/" + this.props.i18n.language + "/" + this.props.t("restaurantes");
      this.props.history.replace(url, true);
    }
  }

  setOrder(value) {
    this.setState({
      order: value,
    });
    localStorage.setItem("order", value);
  }

  setView = () => {
    this.setState({
      view: !this.state.view,
    });
  };

  openModal = () => {
    this.setState({
      open: !this.state.open,
    });
  };

  closeModal = () => {
    this.setState({
      open: false,
    });
  };

  render() {
    const { t, match, i18n } = this.props;
    const { view, order, open } = this.state;

    return (
      <div id="start">
        <BannerTop t={t} type={3} title={t("HeaderRestaurantes")} />
        <Box
          to="restaurants"
          setView={(value) => this.setView(value)}
          view={view}
          setOrder={(value) => this.setOrder(value)}
          order={order}
          t={t}
          i18n={i18n}
        />
        {view ? (
          <List
            t={t}
            i18n={i18n}
            match={match.url}
            to="restaurants"
            order={order}
            perPage={9}
            page={1}
            filter={true}
            activeCategory={false}
            activeMember={true}
            activeCountry={true}
            activeQualification={false}
            activeArea={false}
            pagination={true}
            open={open}
            close={this.closeModal}
          />
        ) : (
          <Maps to="restaurants" go="restaurant" t={t} i18n={i18n} />
        )}
        <NetworkMember>
          <Container>
            <NetworkItem>
              <NetworkIcon>
                <img src={NetIconMembro} alt="" />
              </NetworkIcon>
              <NetworkText>
                <span>{t("RestaurantLegend1")}</span>, {t("RestaurantLegend2")}
                <span>“{t("RestaurantLegend3")}”.</span>
              </NetworkText>
            </NetworkItem>
          </Container>
        </NetworkMember>

        <ButtonFilter onClick={this.openModal}>
          <FaFilter />
        </ButtonFilter>

        <ButtonMap onClick={this.setView}>
          {this.state.view ? <FaMap /> : <MdApps />}
        </ButtonMap>
      </div>
    );
  }
}

export default translate("translations")(Restaurants);

const NetworkMember = styled.div`
  width: 100%;
  padding-top: 50px;
  padding-bottom: 50px;
  margin-top: 30px;
`;
const NetworkItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
`;
const NetworkIcon = styled.div`
  width: 40px;

  img {
    vertical-align: middle;
  }
`;
const NetworkText = styled.div`
  width: calc(100% - 50px);
  color: #666666;
  font-family: "PT Sans";
  font-size: 12px;

  span {
    font-weight: 600;
  }
`;
const ButtonMap = styled.div`
  display: none;
  position: fixed;
  bottom: 15px;
  right: 15px;
  z-index: 10;
  width: 60px;
  height: 60px;
  border-radius: 40px;
  background-color: ${Colors.primary};
  text-align: center;
  line-height: 57px;
  color: white;
  cursor: pointer;
  font-size: 18px;
  box-shadow: 0 2px 6px 0 hsla(0, 0%, 0%, 0.15);

  @media screen and (max-width: 830px) {
    display: block;
  }
`;

const ButtonFilter = styled.div`
  display: none;
  position: fixed;
  bottom: 15px;
  left: 15px;
  z-index: 10;
  width: 60px;
  height: 60px;
  border-radius: 40px;
  background-color: #fff;
  text-align: center;
  line-height: 57px;
  color: white;
  cursor: pointer;
  font-size: 18px;
  color: ${Colors.primary};
  box-shadow: 0 2px 6px 0 hsla(0, 0%, 0%, 0.15);

  @media screen and (max-width: 830px) {
    display: block;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/restaurants/restaurants.page.js